import { As, Box, Icon } from '@chakra-ui/react'
import BarCode, { BarCodeBold } from 'components/Icon/BarCode'
import React from 'react'
import { TYPES_SEARCH_PRODUCTION_ITEM } from '../utils/constants'
import Letter, { LetterBold } from 'components/Icon/Letter'

interface Props {
    type: string
    handleClick: (type: string) => void
}

export default function TypesSearch({ type, handleClick }: Props) {
    return (
        <Box display={'flex'} alignItems={'center'} gap={2}>
            <TypeSearch
                selectedType={type}
                type={TYPES_SEARCH_PRODUCTION_ITEM.NAME}
                icon={
                    type === TYPES_SEARCH_PRODUCTION_ITEM.NAME
                        ? LetterBold
                        : Letter
                }
                handleClick={handleClick}
            />

            <TypeSearch
                selectedType={type}
                type={TYPES_SEARCH_PRODUCTION_ITEM.BAR_CODE}
                icon={
                    type === TYPES_SEARCH_PRODUCTION_ITEM.BAR_CODE
                        ? BarCodeBold
                        : BarCode
                }
                handleClick={handleClick}
            />
        </Box>
    )
}

function TypeSearch({
    selectedType,
    type,
    handleClick,
    icon
}: {
    selectedType: string
    type: string
    handleClick: (value: string) => void
    icon: As<any> | undefined
}) {
    return (
        <Box
            w="10"
            h="full"
            borderRadius={'md'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            border="1px"
            borderColor={selectedType === type ? 'red' : 'gray.300'}
            p={1}
            cursor={'pointer'}
            onClick={() => {
                handleClick(type)
            }}
        >
            <Icon
                as={icon}
                fill={selectedType === type ? 'red' : 'gray-3'}
                fontSize="xl"
            />
        </Box>
    )
}
